import React from "react";
import { FaDribbble, FaGithub, FaInstagram } from "react-icons/fa6";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer">
      <h1 className="Footer-Copyright">
        Copyright © 2023. All rights are reserved
      </h1>
      <div className="Row-Social-Footer">
        <a
          href="https://dribbble.com/rizatzmi"
          target="_blank"
          rel="noreferrer"
        >
          <FaDribbble className="Social-Footer" />
        </a>
        <a href="https://github.com/Rizatzmi">
          <FaGithub className="Social-Footer" />
        </a>
        <a href="https://www.instagram.com/ui.rizatzmi/">
          <FaInstagram className="Social-Footer" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
